// Technical skills data - technologies used by NAIRDC
export const skills = [
  { imageKey: "skillscss", alt: "CSS" },
  { imageKey: "skillshtml", alt: "HTML 5" },
  { imageKey: "skillsjs", alt: "JavaScript" },
  { imageKey: "skillsreact", alt: "React" },
  { imageKey: "skillsvue", alt: "Vue" },
  { imageKey: "skillsflutter", alt: "Flutter" },
  { imageKey: "skillsjupyter", alt: "Jupyter" },
  { imageKey: "skillsseaborn", alt: "Seaborn" },
  { imageKey: "skillsopencv", alt: "OpenCV" },
  { imageKey: "skillssql", alt: "SQL" },
  { imageKey: "skillsnumpy", alt: "NumPy" },
  { imageKey: "skillspython", alt: "Python" },
  { imageKey: "skillsscikit", alt: "Scikit-learn" },
  { imageKey: "skillsjquery", alt: "jQuery" },
  { imageKey: "skillsdjango", alt: "Django" },
  { imageKey: "skillskeras", alt: "Keras" },
  { imageKey: "skillslangchain", alt: "LangChain" },
  { imageKey: "skillsmatplotlib", alt: "Matplotlib" },
  { imageKey: "skillspandas", alt: "Pandas" },
  { imageKey: "skillsplotly", alt: "Plotly" },
  { imageKey: "skillspowerbi", alt: "Power BI" },
  { imageKey: "skillspytorch", alt: "PyTorch" },
  { imageKey: "skillstensor", alt: "TensorFlow" },
];
